import { __assign } from "tslib";
import * as React from 'react';
import { PlaybackContextConsumer } from './PlaybackContext';
function withPlaybackContext(Component) {
    return function WrappedComponent(props) {
        return (React.createElement(PlaybackContextConsumer, null, function (value) { return React.createElement(Component, __assign({}, props, { context: value })); }));
    };
}
export default withPlaybackContext;
//# sourceMappingURL=withPlaybackContext.js.map